"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_ALL_ATTRIBUTE_VALUES_FOR_STRATEGY_MATRIX = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.GET_ALL_ATTRIBUTE_VALUES_FOR_STRATEGY_MATRIX = (0, gql_1.gql)(`
 query GetAllAttributeValues(
    $productTreeNodeId: ID!,
    $first: Int,
    $filter: ProductTreeNodeUniqueLabelListFilter,
    $after: ID
    ) {
  productTreeNode(id: $productTreeNodeId) {
    id
    labelValidation(first: $first, filter: $filter) {
      edges {
        node {
          values(first: $first, after: $after) {
            edges {
              node {
                value
                label
              }
            }
            totalCount
            pageInfo {
              endCursor
              hasNextPage
              hasPreviousPage
              startCursor
            }
          }
        }
      }
    }
  }
}
`);
